import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import logoNextStep from '../../img/logo_final_png.png';
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
import { connect } from 'react-redux'//acepTerms
import { acepTerms } from '../../actions/socialActions'
import { checkCodeReferal,cleanCodeReferal } from '../../actions/regiterActions';

const LoginExternalAcepTerms = ({ acepTerms, history, errorType, location,code,checkCodeReferal,cleanCodeReferal }) => {
    //  var email=location.state.email
    var id = location.state?.id
    useEffect(() => {
        if(location.state?.id==null){
     //       history.push("/Login")
        }
    }, []);
    //  console.log()
    const [phone, setPhones] = useState('')
    const [isAceppTerms, SetIsAceppTerms] = useState(false)
    const [gender, setGender] = useState("")
    const [birthDate, setBirthDate] = useState('Fecha de nacimiento')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(true)
    const [referralCode, setReferralCode] = useState("")

    const [isCodeReferal, setiIsCodeReferal] = useState(false)

    const checkCode = (code) => {
        checkCodeReferal(code)
    }


    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        switch (name) {
            case "phone":
                setPhones(value)
                break;
            case "gender":
                console.log()
                setGender(value)
                break;
            case "birdDate":
                setBirthDate(value)
                break;
                case "referralCode":
                    setReferralCode(value)
            default:
                break;
        }
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }


    }

    

    const goToLoginCode = (e) => {
        e.preventDefault()
        console.log();
        acepTerms(phone, id, history,gender,new Date (birthDate),referralCode)
    }

    return (
        <ViewLogin
            type='phone'
            nameInput='phone'
            img={logoNextStep}
            isExternalLogin={true}
            textWelcome={'¡aceptar terminos' + Translate('textWelcomeLogin', 'es')}
            inputValue={phone}
            error={error.password}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            inputPlaceholder="phone"
            textButton="loginNextButton"
            actionButton={goToLoginCode}
            isAcceptTermsView={true}
            isAcceptTerms={isAceppTerms}
            setIsAcceptTerms={SetIsAceppTerms}
            isBackgroundBlue={true}
            isActiveButton={isAceppTerms}
            gender={gender}
            birthDate={birthDate}
            setBirthDate={setBirthDate}
            referalCode={referralCode}

            code={code}
            checkCode={checkCode}
            isCodeReferal={isCodeReferal}
            cleanCodeReferal={cleanCodeReferal}
            setiIsCodeReferal={setiIsCodeReferal}
            setReferalode={setReferralCode}
            
            history={history}
        />
    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        userEmail: state.register.loginEmail, // y lo que retorna map, connect lo envia a Page como Props 
        isLoading: state.register.isLoadingViewLoginPassword,
        nameUser: state.register.nameUser,
        errorType: state.register.errorType,
        code: state.register.code,
    }
}

export default connect(mapStateToProps, { acepTerms,checkCodeReferal ,cleanCodeReferal})(LoginExternalAcepTerms)

